"use client";

import { useState } from "react";
import Link from "next/link";
import { ChatPanel } from "./ChatPanel";
import { CompanionPicker } from "./CompanionPicker";
import { companions } from "./data";

export function CompanionApp() {
  const [selectedId, setSelectedId] = useState("luna");
  const selected = companions.find((companion) => companion.id === selectedId) ?? companions[0];
  return (
    <main className="app-shell" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:13:5"}>
      <nav className="topbar" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:14:7"}>
        <Link className="brand" href="/" data-amazi-jsx-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:15:9"}>
          <span className="brand-mark" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:16:11"}>✦</span>
          <span data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:17:11"}>lumina</span>
        </Link>
        <span className="topbar-note" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:19:9"}>
          Место для хорошего разговора <span data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:20:40"}>✺</span>
        </span>
        <button className="help-button" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:22:9"}>?</button>
      </nav>
      <div className="workspace" data-amazi-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:24:7"}>
        <CompanionPicker companions={companions} selectedId={selectedId} onSelect={setSelectedId} data-amazi-jsx-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:25:9"} />
        <ChatPanel key={selected.id} companion={selected} data-amazi-jsx-id={"луна-ии-компаньоны/src/features/companion/CompanionApp.tsx:26:9"} />
      </div>
    </main>
  );
}
